import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import { wrapCreateBrowserRouterV6 } from '@sentry/react'
import { ServiceError } from 'entities/Sentry/ui/ServiceError'
import { type EntitiesStore } from 'entities/EntitiesExport'
import { ProviderEntities } from 'entities/EntitiesExport/context/entitiesContext'
import { CallPopUp, type CallPopUpGlobalStore } from 'widgets/CallPopUp'
import { PresentationModeLayout } from 'widgets/PresentationMode'
import { ProviderCallPopUpGlobal } from 'widgets/CallPopUp/context/callPopUpGlobalContext'
import CallPopUpLayout from './layouts/CallPopUpLayout'

const routes = createRoutesFromElements(
  <Route element={<PresentationModeLayout />}>
    <Route element={<CallPopUpLayout />} errorElement={<ServiceError name='call-popup' />}>
      <Route path='/*' element={<CallPopUp />} />
    </Route>
  </Route>
)

const router = wrapCreateBrowserRouterV6(createBrowserRouter)(routes)

type ICallPopupServiceProps = {
  entities: EntitiesStore
  callPopUpGlobalStore: CallPopUpGlobalStore
}

export const CallPopupService = ({ entities, callPopUpGlobalStore }: ICallPopupServiceProps) => (
  <ProviderEntities entities={entities}>
    <ProviderCallPopUpGlobal value={callPopUpGlobalStore}>
      <RouterProvider router={router} />
    </ProviderCallPopUpGlobal>
  </ProviderEntities>
)
